import { useGetList } from 'react-admin';
import { Typography } from '@mui/material';

export const TasksListEmpty = () => {
    const { total } = useGetList('task', {
        pagination: { page: 0, perPage: 1 },
    });

    if (total) return null;

    return (
        <Typography variant="body2">
            Tasks added to your members will appear here.
        </Typography>
    );
};
